import { z } from 'zod';
import { DrnSchema } from '@duke-hq/drn/schema';
import { EmployerContactInputSchema, refineContactMethod } from '../employers/schemas';

export const PlacementContactSchema = z.union([
  z.object({ contactId: z.string().min(1) }).strict(),
  z
    .object({
      newContact: EmployerContactInputSchema.superRefine(refineContactMethod),
      saveAsPrimary: z.boolean().default(false),
    })
    .strict(),
]);

export function contractDocumentUrlSchema(messages: { missing: string; notWebLink: string }) {
  return z
    .string()
    .trim()
    .min(1, messages.missing)
    .url({ protocol: /^https?$/, message: messages.notWebLink });
}

export const ContractDocumentUrlSchema = contractDocumentUrlSchema({
  missing: 'Add the link to the contract document',
  notWebLink: 'Enter a web link starting with http:// or https://',
});

export const CreatePlacementContractSchema = z.object({
  journeyId: z.string().min(1),
  employerId: z.string().min(1),
  contact: PlacementContactSchema,
  documentUrl: ContractDocumentUrlSchema,
});

export type CreatePlacementContractInput = z.input<typeof CreatePlacementContractSchema>;

export const CreateWorkPlacementSchema = z.object({
  courseEnrolmentId: z.number().int().positive(),
  contractId: z.string().min(1),
  agreementFileDrns: z.array(DrnSchema),
  startedAt: z.coerce.date().optional(),
  notes: z.string().optional(),
});

export type PlacementContact = z.infer<typeof PlacementContactSchema>;
export type CreateWorkPlacementInput = z.input<typeof CreateWorkPlacementSchema>;
